import { faro } from '@grafana/faro-web-sdk';
import { MeasurementDetailSchema } from 'common-types';
import { useEffect } from 'react';

function pushMeasurementToFaro() {
  const observer = new PerformanceObserver((entries) => {
    entries.getEntries().forEach((entry) => {
      const details = MeasurementDetailSchema.safeParse(entry);

      if (details.success) {
        // Uncomment this block for local development
        // // eslint-disable-next-line node/no-process-env
        // if (process.env.NEXT_PUBLIC_ENV === 'LOCAL') {
        //   // eslint-disable-next-line no-console
        //   console.log('Performance Metric:', {
        //     name: [entry.name],
        //     context: {
        //       duration: `${entry.duration}`,
        //       ...(details.data.detail || {}),
        //     },
        //   });
        // }

        if (faro?.api?.pushLog) {
          faro.api.pushLog([entry.name], {
            context: {
              duration: `${entry.duration}`,
              ...(details.data.detail || {}),
            },
          });
        }
      }
    });
  });

  observer.observe({ entryTypes: ['measure'] });
  return () => observer.disconnect();
}

export function usePushMeasurementToFaro() {
  useEffect(pushMeasurementToFaro, []);
}
